import { ZodError } from 'zod-validation-error';
import { z } from 'zod';

export type InlineErrorType = {
  path: string;
  message: string;
};

export const parseZodErrorsNew = (error: ZodError) => {
  return error.errors.map((err) => ({
    path: err.path[0] as string,
    message: err.message,
  }));
};

export const addressResultSchemaNew = z.object({
  addressSearch: z
    .array(z.any())
    .nonempty('No address found. Please try again.'),
});

const stringConstraints = (message: string) =>
  z.string().refine((val) => val.length > 0, {
    message,
  });

export const yourDetailsSchemaNew = z.object({
  firstName: stringConstraints('Enter a first name'),
  lastName: stringConstraints('Enter a last name'),
  email: z.string().email('Enter a valid email address'),
});

const createRequiredString = () =>
  z.string().min(1, { message: 'Please select a location on the map' });

const createOptionalString = () =>
  z
    .string()
    .optional()
    .refine((value) => value === undefined || value.length > 0, {
      message: 'Please select a location on the map',
    });

const createRequiredNumber = () =>
  z.number().refine((value) => value !== null && value !== undefined, {
    message: 'Please select a location on the map',
  });

export const addressSchema = z.object({
  address_line_1: createRequiredString(),
  address_line_2: createRequiredString(),
  country: createRequiredString(),
  county: createRequiredString(),
  easting: createRequiredString(),
  latitude: createRequiredNumber(),
  longitude: createRequiredNumber(),
  northing: createRequiredString(),
  postcode: createRequiredString(),
  town_city: createRequiredString(),
  UPRN: createRequiredString(),
  USRN: createRequiredString(),
  full_address: createOptionalString(),
});

const assetErrorMessage = { message: 'Select a nearby road' };
export const assetSchema = z.object({
  site_name: z.string().min(1, { ...assetErrorMessage }),
});
